import cx from 'classnames';
import React from 'react';

import colors from 'utils/colors';
import * as Styling from 'utils/styled';

import * as Elements from './Elements';
import { IconProps } from './interfaces';

const ChevronRight: React.FC<IconProps> = ({
  className = '',
  fill = colors.blueGrey,
  viewBox = '0 0 30.9 50',
  d = 'M0 5.8L19.2 25 0 44.1 5.9 50l25-25-25-25z',
  transition = 'fill 0.1s ease-in-out',
  cssHelper = Styling.fullHeightStyle,
  width = 7,
  height = 15,
  focusable
}) => {
  return (
    <Elements.Svg
      viewBox={viewBox}
      className={cx({ [className]: !!className })}
      width={width}
      height={height}
      cssHelper={cssHelper}
      focusable={!!focusable}
      aria-hidden={!focusable}>
      <Elements.Path fill={fill} d={d} transition={transition} />
    </Elements.Svg>
  );
};

export default ChevronRight;
